<template>
  <div :class="[empty ? 'date-range-grid-empty' : 'date-range-grid']">
    <v-date-picker
      :attributes="attrs"
      is-range
      timezone="UTC"
      mode="date"
      v-model="input"
      :model-config="modelConfig"
      :popover="{ visibility: 'click' }"
      locale="ru">
      <template v-slot="{ inputValue, inputEvents }">
        <div class="flex justify-center items-center">
          <input
            :value="inputValue.start"
            v-on="inputEvents.start"
            :class="textClass"
            autocomplete="off"
            :disabled="disabled"
            placeholder="с даты"
          />
          <svg class="w-4 h-4 mx-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
          </svg>
          <input
            :value="inputValue.end"
            v-on="inputEvents.end"
            :class="textClass"
            class="mh1"
            autocomplete="off"
            :disabled="disabled"
            placeholder="по дату"
          />
        </div>
      </template>
    </v-date-picker>
    <button v-if="!empty && !disabled" @click="input = null" :class="buttonClass">
      <font-awesome-icon icon="times" />
    </button>
  </div>
</template>

<script>
const moment = require('moment')

export default {
  props: {
    mode: { default: 'date' },
    value: { default: null },
    bg: { default: 'light' },
    placeholder: { default: 'введите значение' },
    disabled: { default: false }
  },
  computed: {
    input: {
      get () { return this.value },
      set (v) { this.$emit('input', v) }
    },
    empty () {
      return this.input === null || this.input === undefined || this.input === ''
    }
  },
  data () {
    return {
      modelConfig: {
        type: 'string'
        // timeAdjust: '12:00:00'
        // mask: 'YYYY-MM-DD', // Uses 'iso' if missing
      },
      attrs: [{
        dot: 'blue',
        dates: moment().toISOString()
      }],
      textClass: {
        'text-input': true,
        'bg-light': this.bg === 'light',
        'bg-middle': this.bg === 'dark'
      },
      buttonClass: {
        'input-icon-button': true,
        'bg-light': this.bg === 'light',
        'bg-middle': this.bg === 'dark'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.date-range-grid {
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-rows: auto;
}
.date-range-grid-empty {
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: auto;
}
</style>
